const ja = {
  // Site
  siteName: "琉球グローカル キッズ",
  siteSubtitle: "サマースクール 2026",
  welcome: "琉球グローカル キッズ、サマースクール 2026 へようこそ",
  welcomeSubtitle: "学ぼう。作ろう。発表しよう。お祝いしよう！",

  // Nav
  home: "ホーム",
  myProfile: "マイプロフィール",
  dashboard: "ダッシュボード",
  logout: "ログアウト",
  login: "ログイン",

  // Programs
  programs: "プログラム",
  kidsEntrepreneurship: "キッズ・アントレプレナーシップ",
  aiLiteracy: "AIリテラシー",
  publicPresentation: "パブリックプレゼンテーション",
  eSports: "eスポーツ",
  vedicMathematics: "ヴェーダ数学",
  robotics: "ロボティクス",
  comingSoon: "近日公開",

  // Login
  studentLogin: "生徒ログイン",
  teacherLogin: "先生・スタッフログイン",
  enterCode: "6桁のコードを入力",
  enterEmail: "メールアドレス",
  enterPassword: "パスワード",
  loginBtn: "ログイン",
  forgotPassword: "パスワードを忘れた？",
  backToLogin: "ログインに戻る",
  invalidCode: "コードが無効です。確認してもう一度試してください。",
  loginSuccess: "おかえりなさい！",

  // Days
  day1: "1日目・月曜日",
  day2: "2日目・火曜日",
  day3: "3日目・水曜日",
  day4: "4日目・木曜日",
  day5: "5日目・金曜日",
  theme1: "ビッグアイデア",
  theme2: "お客様を知ろう",
  theme3: "作って・ブランドにしよう",
  theme4: "お金とマーケット",
  theme5: "ピッチ発表の日！",

  // Stamps
  stamps: "スタンプ",
  morning: "午前",
  afternoon: "午後",
  stampEarned: "スタンプ獲得！",
  noStampYet: "まだ獲得していません",
  totalStamps: "合計スタンプ",
  outOf: "/",
  sessions: "セッション",
  giveStamp: "スタンプを渡す",
  stampGiven: "スタンプを渡しました！",

  // Activities
  activity: "アクティビティ",
  worksheet: "ワークシート",
  completed: "完了",
  notCompleted: "未完了",
  saveProgress: "保存する",
  saved: "保存しました！",

  // Profile
  studentProfile: "生徒プロフィール",
  enrolledIn: "参加中",
  weekProgress: "1週間の進捗",
  myBusinessIdea: "私のビジネスアイデア",
  problemSolving: "解決したい問題",
  myIdea: "私のアイデア",
  myCustomer: "私のお客様",
  myPrice: "価格",
  businessName: "ビジネス名",
  slogan: "スローガン",

  // Awards
  awards: "表彰",
  mostCreative: "最もクリエイティブなアイデア",
  mostCustomerFocused: "お客様視点賞",
  bestBrand: "ベストブランド＆ロゴ",
  bestProblemSolver: "問題解決賞",
  bravestPitcher: "チャレンジ精神賞",
  mostImproved: "最優秀成長賞",
  bestTeamPlayer: "ベストチームプレーヤー",
  mostLikelyToSucceed: "成功可能性大賞",

  // Certificate
  certificate: "修了証",
  certText: "ここに証明します",
  certText2: "が、以下のプログラムを修了したことを",
  certText3: "琉球グローカル キッズ サマースクール 2026",
  certText4: "キッズ・アントレプレナーシッププログラム",
  certDate: "2026年夏、沖縄県",
  printCertificate: "修了証を印刷",
  printBooklet: "ブックレットを印刷",

  // Teacher Dashboard
  teacherDashboard: "先生ダッシュボード",
  allStudents: "全生徒",
  lastActivity: "最終活動",
  viewProfile: "プロフィールを見る",
  giveAward: "表彰する",
  selectDay: "日を選択",
  selectSession: "セッションを選択",

  // Admin
  adminDashboard: "管理者ダッシュボード",
  inviteTeacher: "先生を招待",
  addStudent: "生徒を追加",
  totalTeachers: "先生数",
  totalStudents: "生徒数",
  totalStampsGiven: "渡したスタンプ数",
  sendInvite: "招待を送る",
  teacherEmail: "先生のメールアドレス",

  // Misc
  loading: "読み込み中...",
  error: "エラーが発生しました",
  notFound: "ページが見つかりません",
  backHome: "ホームに戻る",
  okinawa: "沖縄県、日本",
};

export default ja;
